import React from 'react'
import HeroBlock from 'gatsby-theme-kn/src/components/blocks/HeroBlock'
import SocialShareBlock from 'gatsby-theme-kn/src/components/blocks/SocialShareBlock'
import Layout from 'gatsby-theme-kn/src/components/modules/Layout'
import BodyBlocks from 'gatsby-theme-kn/src/components/technical/BodyBlocks'
import ArticleTripleTeaserBlock from 'gatsby-theme-kn/src/components/blocks/ArticleTripleTeaserBlock'
import SEO from 'gatsby-theme-kn/src/components/modules/Seo'

const ContentPage = ({ locale, content, name, alternates }) => {
  return (
    <div>
      <Layout locale={locale} alternates={alternates}>
        <SEO content={content} title={name} />
        <HeroBlock
          useStoryblokImage
          block={{
            headline: content.headline?.length > 0 ? content.headline : name,
            image: content.header_image,
            reduced_height: content.reduced_height,
          }}
        />
        <SocialShareBlock />
        <BodyBlocks body={content.body} />

        {content.collection?.length > 0 && (
          <ArticleTripleTeaserBlock
            block={{}}
            data_source={content.collection}
          />
        )}
      </Layout>
    </div>
  )
}

export default ContentPage
